// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:25
import { CNote_abstract } from './../abstract/SagaSchema/CNote_abstract';
export class CNote extends CNote_abstract {}
